const L = {
  name: "Move",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.5857 13.0002L17.5858 15.0002L19 16.4144L23.4142 12.0002L19 7.58594L17.5858 9.00015L19.5858 11.0002L13.0001 11.0002L13.0001 4.41427L15.0002 6.41436L16.4144 5.00015L12.0002 0.585938L7.58594 5.00015L9.00015 6.41436L11.0001 4.41446L11.0001 11.0002L4.41439 11.0002L6.41436 9.00021L5.00015 7.58599L0.585938 12.0002L5.00015 16.4144L6.41436 15.0002L4.41434 13.0002L11.0001 13.0002L11.0001 19.5861L8.99996 17.586L7.58575 19.0002L12 23.4144L16.4142 19.0002L15 17.586L13.0001 19.5859L13.0001 13.0002L19.5857 13.0002Z" fill="currentColor"/>
</svg>
  `
};
export {
  L as Move
};
